/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CLEAR_NOTIFICATION_MESSAGE_PROMPT,
  SET_ADD_EP_PAX,
  SET_ADD_ET_PAX,
  SET_ADD_ROOMS_ACTIVITY,
  SET_ADD_ROOMS_APARTMENT,
  SET_ADD_ROOMS_HOTEL,
  SET_ADD_ROOMS_TRANSFER,
  SET_CLEAR_LOCAL_STORAGE,
  SET_LOCAL_STORAGE,
  SET_NOTIFICATION_MESSAGE_PROMPT,
  // SET_QUOTES_ACTIVITIES,
  SET_QUOTES_REF,
  // SET_QUOTES_ROOMS,
  // SET_QUOTES_TRANSFERS,
  SET_SEARCH_TYPE_LOCAL_STORAGE,
} from "../actionTypes/localStorageActionTypes";

const initialState = {
  CompareRooms: [],
  // LocalQuoteRooms: [],
  // localQuoteActivities: [],
  UserQuoteRef: "",
  AddRoomsHotel: [],
  AddRoomsApartment: [],
  AddRoomsTransfer: [],
  AddRoomsActivity: {},
  AddETPax: {},
  AddEPPax: {},
  NotificationMessage: {},
  searchSuggestionType: "",
};

const localStorageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LOCAL_STORAGE:
      return {
        ...state,
        CompareRooms: action.payload,
      };
    // case SET_QUOTES_ROOMS:
    //   return {
    //     ...state,
    //     LocalQuoteRooms: action.payload,
    //   };
    // case SET_QUOTES_TRANSFERS:
    //   return {
    //     ...state,
    //     LocalQuoteTransfers: action.payload,
    //   };
    // case SET_QUOTES_ACTIVITIES:
    //   return {
    //     ...state,
    //     localQuoteActivities: action.payload,
    //   };
    case SET_QUOTES_REF:
      return {
        ...state,
        UserQuoteRef: action.payload,
      };
    case SET_ADD_ROOMS_HOTEL:
      return {
        ...state,
        AddRoomsHotel: action.payload,
      };
    case SET_ADD_ROOMS_APARTMENT:
      return {
        ...state,
        AddRoomsApartment: action.payload,
      };
    case SET_ADD_ROOMS_ACTIVITY:
      return {
        ...state,
        AddRoomsActivity: action.payload,
      };
    case SET_ADD_ROOMS_TRANSFER:
      return {
        ...state,
        AddRoomsTransfer: action.payload,
      };
    case SET_ADD_ET_PAX:
      return {
        ...state,
        AddETPax: action.payload,
      };
    case SET_ADD_EP_PAX:
      return {
        ...state,
        AddEPPax: action.payload,
      };
    case SET_CLEAR_LOCAL_STORAGE:
      return {
        ...state,
        CompareRooms: [],
        // LocalQuoteRooms: [],
        // LocalQuoteTransfers: [],
        // localQuoteActivities: [],
        UserQuoteRef: "",
        AddRoomsHotel: [],
        AddRoomsApartment: [],
        AddRoomsTransfer: [],
        AddRoomsActivity: {},
        AddETPax: {},
        AddEPPax: {},
        searchSuggestionType: "",
      };
    case SET_NOTIFICATION_MESSAGE_PROMPT:
      return {
        ...state,
        NotificationMessage: action.payload,
      };
    case CLEAR_NOTIFICATION_MESSAGE_PROMPT:
      return {
        ...state,
        NotificationMessage: {
          isOpen: false,
          mainHeader: "",
          subHeader: "",
          message: "",
          isSubReq: false
        },
      };
    case SET_SEARCH_TYPE_LOCAL_STORAGE:
      return {
        ...state,
        searchSuggestionType: action.payload,
      };
    default:
      return state;
  }
};

export default localStorageReducer;
